
export const SCFUsageCode = 'SC001';
const reportConfig = [
  {
    name: 'Enterprise Report',
    code: 'M002',
    isInterval: false,
  },
  {
    name: 'Error Report',
    code: 'M003',
    isInterval: false,
  },
  {
    name: 'Overall Usage',
    code: 'M004',
    isInterval: false,
  },
  {
    name: 'API Performance',
    code: 'M005',
    isInterval: false,
  },
  {
    name: 'Enterprise Usage',
    code: 'M006',
    isInterval: true,
  },
  {
    name: 'Enterprise Engagement',
    code: 'M007',
    isInterval: true,
  },
  {
    name: 'Smart Construction Usage',
    code: SCFUsageCode,
    isInterval: false,
    isSCUsage: true
  },
];


export default reportConfig;



// WEBPACK FOOTER //
// ./src/constants/reportConfig.js